import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for Brevo transactional message events.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = async listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.BREVO_TRANSACTIONAL_MESSAGE_EVENTS,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const BrevoTransactionalMessageEventService = {
  FindMany
}

export default BrevoTransactionalMessageEventService
